import Qs from 'qs'
/**
 * 从url读取查询参数
 */
export const readQueryFromUrl = () => {
    return Qs.parse(window.location.search, { ignoreQueryPrefix: true })
}
